import type { ChecklistItemConfig } from "@smartsuite/automation-engine-api";
import type { ChecklistItemConfigCandidate } from "../../../../../../../../types/checklist";

export const getHashFromChecklistItemConfig = (
  item: ChecklistItemConfig,
): string => (item as ChecklistItemConfigCandidate).hash;

export const getCandidatesFromChecklistItemConfigs = (
  items: ChecklistItemConfig[],
): ChecklistItemConfigCandidate[] => items as ChecklistItemConfigCandidate[];
